import { Card, CardBody, Col } from "reactstrap";
import { OfferStyleBorderTitle } from "../../../../../../Constants/Constants";
import { OfferStyleBorderSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import OfferStyleBorderForm from "./OfferStyleBorderForm";

const OfferStyleBorder = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={OfferStyleBorderTitle} span={OfferStyleBorderSubTitle} />
        <CardBody className="megaoptions-border-space-sm">
          <OfferStyleBorderForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="success" color2="transparent" btn2Class="list-light-success" />
      </Card>
    </Col>
  );
};
export default OfferStyleBorder;
